/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/root.reducers';

const URLChangeEvents: FunctionComponent = (): JSX.Element => {
    const urlChangeEvents = useSelector((state: RootState) => state.urlChangeEvents);
    const { url } = urlChangeEvents;
    return <Redirect to={{ pathname: url }} />;
};

export default URLChangeEvents;
